import Vue from 'vue'
import App from './views/index.vue'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import './static/css/base.less'
import './static/css/lexus-font.css'
import registerServiceWorker from './sw'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false

const mountApp = () => {
    new Vue({
        store,
        render: h => h(App)
    }).$mount('#app')
}

registerServiceWorker().then(mountApp, mountApp)
